import { useCallback, useState } from 'react';

export const useHover = (): [boolean, { onMouseOver: () => void; onMouseOut: () => void }] => {
  const [isHovered, setIsHovered] = useState(false);
  const onMouseOver = useCallback(() => setIsHovered(true), []);
  const onMouseOut = useCallback(() => setIsHovered(false), []);
  return [isHovered, { onMouseOver, onMouseOut }];
};
